<template>
    <div>
        <v-card class="pa-2" color="#E57373">
            <canvas id="chart3" ref="chart3" width="400" height="300"></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            labels: [],
            amount: [],
            volume: []
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            if(this.chart && this.canvas) {
                this.chart.destroy();
                this.canvas = null;
            }
            
            this.labels = this.chartData.map(e => e.day);
            this.amount = this.chartData.map(e => e.revenueFailed);
            this.volume = this.chartData.map(e => e.revenueVolFailed);

            this.canvas = this.$refs['chart3'].getContext('2d');
            let chartData = { datasets: [] };
            chartData.datasets.push({ label: 'Value',
                                      data: this.amount,
                                      borderColor: '#FFF',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(255, 255, 255, 0.3)" });
            chartData.datasets.push({ yAxisID: 2,
                                      data: this.volume,
                                      label: 'Volume',
                                      backgroundColor: '#FFF',
                                      borderColor: '#FFF',
                                      borderWidth: 1,
                                      fill: false,
                                      borderDash: [2],
                                      type: 'line' });

            this.chart = new Chart(this.canvas, {
                type: 'bar',
                data: {
                    labels: this.labels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: 'Daily Failed Revenue',
                        fontSize: 14,
                        fontStyle: 400,
                        fontColor: '#FFF'
                    },
                    scales: {
                        yAxes: [{
                            positions: 'left',
                            ticks: {
                                id: 1,
                                beginAtZero: true,
                                maxTicksLimit: 10,
                                fontSize: 10,
                                fontColor: '#FFF',
                                callback: function(value) {
                                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0 }).format(value);
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Value',
                                fontSize: 12,
                                fontColor: '#FFF'
                            },
                            gridLines: {
                                zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                color: "rgb(255, 255, 255, 0.2)"
                            }
                        },
                        {
                            id: 2,
                            position: 'right',
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                fontColor: '#FFF',
                                callback: function(value) {
                                    return value;
                                }
                            },
                            gridLines: {
                                display: false
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Volume',
                                fontSize: 12,
                                fontColor: '#FFF'
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                fontColor: '#FFF'
                            },
                            scaleLabel: {
                                display: false,
                                labelString: 'Days',
                                fontSize: 12,
                                fontColor: '#FFF'
                            },
                            gridLines: {
                                zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                color: "rgb(255, 255, 255, 0.2)"
                            }
                        }]
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 10,
                            fontColor: '#FFF',
                            usePointStyle: true
                        },
                        position: 'bottom'
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltip) {
                                if(tooltip.datasetIndex != 1) {
                                    return `Value: ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2 }).format(tooltip.value)}`;
                                }
                                else {
                                    return `Volume: ${tooltip.value}`;
                                }
                            }
                         }
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>